
























import { Component, Vue } from 'vue-property-decorator';
import CustomButton from './CustomButton.vue';
import { EButtonMode } from '../../common/enums/button.enum';

@Component({
  components: { CustomButton },
  name: `JobsCookieInfo`,
})
export default class JobsCookieInfo extends Vue {
  protected EButtonMode = EButtonMode;
}
